import React, { Component } from "react";
import { FormRadio as SemanticFormRadio } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { observer } from "mobx-react";
import NestStore from "../../../stores/NestStore";
import FormHelper from "../../../utils/FormHelper";

@observer
class FormRadio extends Component {
  handleOnChangeRadio = (e, data) => {
    const { dataStore, name } = this.props;
    _.set(dataStore, name, FormHelper.convertToValue(data.value));
  };

  render() {
    const { dataStore, name, options, value, onChange, checked, renderOnSelect, defaultValue, ...props } = this.props;
    let varValue = _.get(dataStore, name, "");
    if (defaultValue && varValue === null) {
      varValue = defaultValue;
    }
    varValue = FormHelper.convertToString(varValue);
    const propValue = FormHelper.convertToString(value);
    const error = _.get(dataStore.errorMessages, name, undefined);
    return (
      <>
        <SemanticFormRadio
          checked={checked !== undefined ? checked : varValue === propValue}
          value={propValue}
          name={name}
          error={error}
          onChange={onChange || this.handleOnChangeRadio}
          {...props}
        />
        {checked ? renderOnSelect : []}
      </>
    );
  }
}
FormRadio.propTypes = {
  ...SemanticFormRadio.propTypes,
  dataStore: PropTypes.instanceOf(NestStore).isRequired,
  defaultValue: PropTypes.any,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  checked: PropTypes.bool, // if not provided, value will be calculated
  renderOnSelect: PropTypes.element,
};
export default FormRadio;
